module.exports = __webpack_public_path__ + "static/media/Tile Image - Sero Marry me.e894eeb6.png";